import { useState, useEffect } from 'react'
import { ProfileSettings } from '../components/ProfileSettings'
import GuestAccessTab from '../components/GuestAccessTab'
import { authService } from '../services/auth'

type TabType = 'profile' | 'guest-access'

export default function ProfilePage() {
  const [activeTab, setActiveTab] = useState<TabType>('profile')
  const [isGuest, setIsGuest] = useState<boolean | null>(null)

  // Check if current user is a guest - guests cannot invite other guests
  useEffect(() => {
    const checkUserRole = async () => {
      try {
        const session = await authService.getSession()
        const userRole =
          session?.user?.user_metadata?.role?.toUpperCase() || session?.user?.app_metadata?.role?.toUpperCase()
        setIsGuest(userRole === 'GUEST')
      } catch (error) {
        console.error('Failed to check user role:', error)
        setIsGuest(false)
      }
    }
    checkUserRole()
  }, [])

  // Show only profile tab if user is a guest (guests cannot invite other guests)
  const showGuestAccessTab = isGuest === false

  return (
    <div className="space-y-6 p-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Profile</h1>
        <p className="text-gray-600">Manage your personal information and account details</p>
      </div>

      {/* Tab Navigation - only show Guest Access tab for non-guest users */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          <button
            onClick={() => setActiveTab('profile')}
            className={`${
              activeTab === 'profile'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors`}
          >
            Profile Settings
          </button>
          {showGuestAccessTab && (
            <button
              onClick={() => setActiveTab('guest-access')}
              className={`${
                activeTab === 'guest-access'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors`}
            >
              Guest Access
            </button>
          )}
        </nav>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'profile' && <ProfileSettings />}
        {activeTab === 'guest-access' && showGuestAccessTab && <GuestAccessTab />}
      </div>
    </div>
  )
}
